import { IndexPageCategory } from 'features/index/IndexPageCategory'

export const IndexPage = () => {
  return <IndexPageCategory label="Latest Added" indexCategory="mostPopular" />
}
